import Footer from '../../components/Commons/Footer';
import NavBar from '../../components/Commons/NavBar';
import MovieCard from '../../components/Movies/MovieCard';
import { ListContents, Grid, TitleList, WithoutContent, CardWrapper } from './style';
import EmptyList from '../../assets/icon-empty.svg';
import { useState } from 'react';
import { useEffect } from 'react';
import GridSkeleton from '../../components/Commons/GridSkeleton';
import { getContentTag, getTrailTag } from '../../services/tags';
import { Mobile } from 'utils/responsiveRules';
import MobileNavigatorSpace from 'components/Commons/MobileNavigatorSpace';

const NoContent = () => (
  <WithoutContent>
    <div>
      <img src={EmptyList} alt="" />
    </div>
    <p>Nenhum conteúdo a esta categoria no momento. Navegue pelo catálogo para encontrar mais conteúdos.</p>
  </WithoutContent>
);

export default function Lectures() {
  const [content, setContent] = useState<any>();

  const getData = async () => {
    const content = await getContentTag('palestras');
    const trail = await getTrailTag('palestras');
    setContent(content.concat(trail));
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <NavBar />
      <ListContents>
        <TitleList>Palestras</TitleList>
        {!content && <GridSkeleton />}
        {content?.length <= 0 && <NoContent />}
        <Grid>
          {content &&
            content.map((lecture: any, key: any) => {
              if (lecture?.is_library) {
                return (
                  <CardWrapper>
                    <MovieCard to={`/movie/${lecture.content_id}`} data={lecture} key={`lecture-${key}`} />
                  </CardWrapper>
                );
              } else {
                return (
                  <CardWrapper>
                    <MovieCard to={`/trail/${lecture.trail_id}`} data={lecture} key={`lecture-${key}`} />
                  </CardWrapper>
                );
              }
            })}
        </Grid>
      </ListContents>
      <Footer />
      <Mobile>
        <MobileNavigatorSpace />
      </Mobile>
    </>
  );
}
